var map = {
	"./blogs.json": "0cba",
	"./cases.json": "c850",
	"./forms/contact_us.json": "21e2",
	"./forms/contact_us_cn.json": "1220",
	"./forms/email_subscription.json": "b7fe",
	"./globals/agile_teams.json": "8e5e",
	"./globals/footer.json": "4447",
	"./globals/settings.json": "a172",
	"./pages/about.json": "4457",
	"./pages/blog.json": "6711",
	"./pages/contact-us.json": "2b81",
	"./pages/home.json": "1a2d7",
	"./pages/open-source.json": "29ce",
	"./pages/what-we-do.json": "21a7",
	"./services.json": "48c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "365c";